module.exports = __webpack_public_path__ + "img/help_1.9d6c3814.png";